export default __webpack_public_path__ + "static/media/solution-top.38f135dd.svg";